import SparkMD5 from "spark-md5";
import CryptoJS from 'crypto-js';
import Fingerprint2 from 'fingerprintjs2';
/**
 * 工具类
 * 依赖jquery
 */
export default {
    /**
     * 给元素绑定拖拽上传事件
     * @param  string       element         dom元素
     * @param  function     dropCallback    松手时回调函数
     * @param  function     enterCallback   悬浮时回调函数
     */
	bindDragEvent: function (element, dropCallback=false, enterCallback=false) {
        $(element).on("drop", function(e){
            //获取文件列表
            var fileList = e.originalEvent.dataTransfer.files;
            //检测是否是拖拽文件到页面的操作
            if(fileList.length == 0) {
                return false;
            }

            let file = fileList[0]

            if (dropCallback) {
                dropCallback(file)
            }
            e.preventDefault();
            return false;
        })

        $(element).on('dragenter', function(e) {
            if(enterCallback) enterCallback()
            e.preventDefault()
        })

        $(element).on('dragover', function(ev) {
            ev.preventDefault();
            //return false;
        })
    },

    /**
     * 将图片转化为base64
     * @param  imgObj   img     图像对象
     * @return string   base64  转化的base64码
     */
	getBase64Image: function (img) {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height);
        var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
        var dataURL = canvas.toDataURL('image/' + ext);
        return dataURL;
    },

    /**
    * 获取css值
    * @param  obj      obj dom对象
    * @param  string   key 要获取的css的名字
    * @return string       获取的css的值
    */
	getCss: function (obj, key) {
        return obj.currentStyle ? obj.currentStyle[key] : document.defaultView.getComputedStyle(obj, false)[key];
    },

    /**
     * 获取指定ID的dom元素
     */
    ID: function (id) {
        return document.getElementById(id);
    },

    /**
     * 返回格式化的年月日日期
     */
    format_time: function () {
        let time = new Date()
        let year = time.getFullYear()
        let month = time.getMonth()
        let date = time.getDate()
        return year + '-' + month + '-' + date
    },

    /**
     * 设备检测看是手机还是电脑
     * @return  bool   电脑返回true， 手机返回false
     */
    browserIsPc: function () {
    　　var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsMacos = sUserAgent.match(/mac/i) == "mac";
    　　var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    　　var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    　　var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    　　var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    　　var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    　　var bIsAndroid = sUserAgent.match(/android/i) == "android";
    　　var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    　　var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    　　if ((bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) ){
    　　　　return false
    　　} else if(bIsMacos && 'ontouchend' in document) {
            return false
        }else {
    　　　　return true
    　　}　　　　
    },    /**
    * 设备检测看是否为手机
    * @return  bool   电脑返回true， 手机返回false
    */
   browserIsMobile: function () {
       var ua = navigator.userAgent,
       isWindowsPhone = /(?:Windows Phone)/.test(ua),
       isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
       isAndroid = /(?:Android)/.test(ua),
       isFireFox = /(?:Firefox)/.test(ua),
       isChrome = /(?:Chrome|CriOS)/.test(ua),
       isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
       isPhone = /(?:iPhone)/.test(ua) && !isTablet,
       isPc = !isPhone && !isAndroid && !isSymbian;

       if (isAndroid || isPhone) {
           return true
       }
       return false
   },

    /**
     * 加载图片
     * @param  string   url     图片链接
     * @param  function success 加载成功回调
     * @param  function error   加载失败回调
     */
    loadImage: function(url, success, error) {
        let img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.crossOrigin = 'anonymous';
        img.src = url;
        img.onload = function() {
            if (success) {
                success(img)
            }
        }
        img.onerror = function() {
            if (error) {
                error(img)
            }
        }
    },

    /**
     * 显示操作台
     * @param  string   selector    可选取的dom元素
     */
    showMask: function(selector) {
        window.scrollTo(0,0)
        document.documentElement.style.overflowY = 'hidden';
        document.documentElement.style.position = 'fixed';
        document.documentElement.style.width = '100%';
        document.documentElement.style.height = '100%';
        if (selector)
            document.querySelector(selector).style.display = 'flex'
    },

    /**
     * 关闭操作台
     * @param  string   selector    可选取的dom元素
     */
    closeMask: function(selector) {
        document.documentElement.style.overflowY = 'auto';
        document.documentElement.style.position = 'relative'
        document.querySelector('.mask').style.display = 'none'
        if (selector)
            document.querySelector(selector).style.display = 'none'
    },

    /**
     * 生成圆形的鼠标形状
     * @param  number   size  尺寸
     * @param  sting    color 颜色
     * @return sting       生成的图片url
     */
    makeCursor: function (size, color) {
        color = color ? color : 'rgba(255, 15, 3)'
        var canvas = document.createElement('canvas');
        canvas.width = canvas.height = size;
        var ctx = canvas.getContext("2d");
        ctx.globalAlpha = 0.7;
        ctx.beginPath();
        var radius = Math.round(size / 2);
        ctx.arc(radius, radius, radius, 0, 2 * Math.PI);
        ctx.fillStyle = color;
        ctx.fill();
        return 'url(' + canvas.toDataURL('image/cur') + ')' + radius + ' ' + radius + ', default';
    },

    /**
     * 将base64转化为blob
     * @param  base64  urlData 
     * @return bolb         
     */
    convertBase64UrlToBlob: function (urlData){
        var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type:mime});
    },
    
    /**
     * 节流函数（定时器）
     */
    throttle: function(callback, time) {
        if (!window.canRun) {
            return;
        }
        window.canRun = false;
        var context = this;               
        var args = arguments;  
        //console.log(context, args)
        setTimeout(function() {
            callback.apply(context, args);
            window.canRun = true;
        }, time);
    },

    /**
     * 判断IE浏览器的版本
     */
    IEVersion: function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if(fIEVersion == 7) {
                return 7;
            } else if(fIEVersion == 8) {
                return 8;
            } else if(fIEVersion == 9) {
                return 9;
            } else if(fIEVersion == 10) {
                return 10;
            } else {
                return 6;//IE版本<=7
            }   
        } else if(isEdge) {
            return 'edge';//edge
        } else if(isIE11) {
            return 11; //IE11  
        }else{
            return -1;//不是ie浏览器
        }
    },

    /**
     * 文件md5加密
     * @param  {[type]} ofile [description]
     * @return string       加密返回的md5值
     */
    getFilemd5: function (ofile, callback) {
        var file = ofile;
        var tmp_md5 = null;
        var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
            chunkSize = 8097152,
            chunks = Math.ceil(file.size / chunkSize),
            currentChunk = 0,
            spark = new SparkMD5.ArrayBuffer(),
            fileReader = new FileReader();
        fileReader.onload = function (e) {
            spark.append(e.target.result);
            currentChunk++;
            if (currentChunk < chunks) {
                loadNext();
            } else {
                callback(spark.end())
            }
        };

        fileReader.onerror = function () {
            console.warn('oops, something went wrong.');
        };

        function loadNext() {
            var start = currentChunk * chunkSize,
                end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
            fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        }
        loadNext();
    },

    /**
     * 加密
     */
    encrypt: function(str) {
        var key  = CryptoJS.enc.Latin1.parse('5FA2MKT7miJ/sGTb');
        var iv   = CryptoJS.enc.Latin1.parse('Aryx2NC77xtTX8Ju');
        var encrypted = CryptoJS.AES.encrypt(str, key,{
            iv:iv,
            mode:CryptoJS.mode.CBC,
        });

        return encrypted.toString();
    },
    // 获取浏览器唯一码
    murmur:function(){
        let options = {'excludes': {'userAgent':true,'audio':true,'enumerateDevices':true,'fonts':true,'fontsFlash':true,'canvas':true}}
        let murmur=1;
        Fingerprint2.get(options, function (components) {
            // 参数
            const values = components.map(function (component) {
                return component.value;
            });
            // 指纹
            murmur = Fingerprint2.x64hash128(values.join(''), 31);
        });
        return murmur;
    }
}